import HealthBar from "../../../components/Reusable/HealthBar";
import Text from "../../../components/Reusable/Text";
import styles from "./TimeRemaining.module.css";

const TimeRemaining = ({
  isSmall,
  value = Date.now(),
  max = Date.now() + 1000 * 60 * 60 * 24 * 10,
  min = Date.now(),
}: {
  isSmall?: boolean;
  value?: number;
  max?: number;
  min?: number;
}) => {
  const diff = max - Date.now();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  if (isSmall) return <HealthBar value={value} min={min} max={max} />;
  return (
    <div className={styles.component}>
      <div className={styles.info}>
        <Text variant="Body2" color="Grey">
          TIME REMAINING
        </Text>
        <Text variant="Body2" color="White">
          {`${days} DAYS ${hours} HOURS ${minutes} MINUTES`}
        </Text>
      </div>
      <div className={styles.barContainer}>
        <HealthBar value={value} min={min} max={max} />;
      </div>
    </div>
  );
};

export default TimeRemaining;
